import React, { useEffect } from 'react';
import { Pane, TickCircleIcon, ArrowLeftIcon } from 'evergreen-ui';
import styles from './CompleteOrder.module.css';
import { AnchorComponent, ButtonLink } from '../../components';
import ShareLinks from '../../components/ShareLinks';
import { Environment } from 'services/Environment';

const ConfirmationScreen = ({ subdomain, order, course, educator }) => {
    useEffect(() => {
        if (order) {
            window.analytics.track('Complete Order Successful', {
                order_id: order._id,
                content_ids: [order._id],
                contents: [{ id: order._id, items: order.items }],
                items: order.items,
                value: order.total_cost,
                currency: 'GBP',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const backToCoursesCta = () => {
        return (
            <ButtonLink to="/" margin="0 10px 0 0">
                <ArrowLeftIcon marginRight={10} />
                Back to course list
            </ButtonLink>
        );
    };

    const SocialCTAs = () => {
        const shareText = encodeURIComponent(
            `I just booked ${course.name} with ${course.educator.name}. Check it out:`
        );
        const shareLink = () => {
            if (subdomain && course && educator.slug && course.slug)
                return `https://${educator.slug}.${Environment.DOMAIN}/${course.slug}`;
            if (course && educator.slug && course.slug)
                return `${Environment.MARKETPLACE_URL}/${educator.slug}/${course.slug}`;
            return `${Environment.MARKETPLACE_URL}`;
        };

        return <ShareLinks shareLink={shareLink} shareText={shareText} />;
    };

    return (
        <>
            <Pane>
                <Pane
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    textAlign="center"
                    marginTop={30}
                >
                    <TickCircleIcon color="success" size={100} />
                    <h1>Order complete</h1>
                    {course && course.approval_required ? (
                        <p>
                            Expect a confirmation email from{' '}
                            {course.educator?.name || ' the course provider '} shortly.
                        </p>
                    ) : (
                        <p>Check your email for a link to manage your order.</p>
                    )}

                    <p>
                        {order && (
                            <span style={{ color: 'var(--text-muted)' }}>
                                Order reference: <span id="order-id">{order._id}</span>
                                <AnchorComponent
                                    href={`${Environment.API_URL}/order/${order._id}/invoice`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block' }}
                                >
                                    Download receipt
                                </AnchorComponent>
                            </span>
                        )}
                    </p>
                    <Pane className={styles.confirmation_screen_buttons}>{backToCoursesCta()}</Pane>

                    <SocialCTAs />
                </Pane>
            </Pane>
        </>
    );
};

export default ConfirmationScreen;
